export default __webpack_public_path__ + "static/media/ic_products_white.dff8ee46.svg";